export enum WaitingPeriod {
  DAYS_30 = '30 days',
  DAYS_60 = '60 days',
  DAYS_90 = '90 days',
  DAYS_180 = '180 days',
  DAYS_365 = '1 year',
  DAYS_730 = '2 years',
}
